import { render, staticRenderFns } from "./GridLayoutPlaceholder.vue?vue&type=template&id=27108e84&scoped=true&"
import script from "./GridLayoutPlaceholder.vue?vue&type=script&lang=js&"
export * from "./GridLayoutPlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./GridLayoutPlaceholder.vue?vue&type=style&index=0&id=27108e84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27108e84",
  null
  
)

export default component.exports